import { OpsLayout } from '@/components/ops/OpsLayout';
import { TaxonomyImporter } from '@/components/admin/taxonomy/TaxonomyImporter';
import { Database, ShieldCheck } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export default function TaxonomyImportPage() {
  return (
    <OpsLayout>
      <div className="p-6 space-y-6 max-w-7xl mx-auto">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Database className="w-6 h-6 text-primary" />
            Bulk Clinical Taxonomy Importer
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Ingest specialty CPT catalogs, ICD-10 sets, and NCCI bundling rules. Quarterly CMS updates supported via upsert.
          </p>
        </div>

        <Alert>
          <ShieldCheck className="w-4 h-4 text-primary" />
          <AlertTitle>CPT Licensing Zero-Fact Policy</AlertTitle>
          <AlertDescription>
            Columns labeled <span className="font-mono">Full Descriptor</span>,{' '}
            <span className="font-mono">Long Descriptor</span>,{' '}
            <span className="font-mono">Copyrighted Text</span>, or{' '}
            <span className="font-mono">AMA Descriptor</span> are stripped client-side and rejected
            server-side. Only Code, Short Label, Base RVU, and Specialty Domain are persisted.
          </AlertDescription>
        </Alert>

        <TaxonomyImporter />
      </div>
    </OpsLayout>
  );
}
